import React from 'react';
import { ArrowRight, Star, Hotel } from 'lucide-react';
import { SectionDivider } from './SectionDivider';
export function DemosSection() {
  const demos = [{
    title: 'Mr Neo Body — Landing Page',
    subtitle: 'Resort & Spa Landing Page Demo',
    url: 'https://project-amit-resort-hua-hin-landing-page-303.magicpatterns.app/',
    thumbnail: 'https://image.thum.io/get/width/600/crop/400/https://project-amit-resort-hua-hin-landing-page-303.magicpatterns.app/',
    gradient: 'from-amber-900/80 to-yellow-900/60'
  }, {
    title: 'Hotel Hua Hin — Redesign Concept',
    subtitle: 'Modern Hotel Website Redesign',
    url: 'https://project-bihai-hua-hin-resort-website-redesign-401.magicpatterns.app/',
    thumbnail: 'https://image.thum.io/get/width/600/crop/400/https://project-bihai-hua-hin-resort-website-redesign-401.magicpatterns.app/',
    gradient: 'from-emerald-900/80 to-teal-900/60'
  }, {
    title: 'Hua Hin Hotel — Clean Version',
    subtitle: 'Clean & Structured Hotel Website',
    url: 'https://project-the-bihai-hua-hin-resort-website-184.magicpatterns.app/',
    thumbnail: 'https://image.thum.io/get/width/600/crop/400/https://project-the-bihai-hua-hin-resort-website-184.magicpatterns.app/',
    gradient: 'from-blue-900/80 to-indigo-900/60'
  }];
  const testimonials = [{
    name: 'Sarah M.',
    role: 'Restaurant Owner',
    text: 'Our bookings doubled within the first month. The website looks incredible.'
  }, {
    name: 'James K.',
    role: 'Barber Shop',
    text: 'Best investment I made for my business. Clients find us so easily now.'
  }, {
    name: 'Mike O.',
    role: 'Plumbing Services',
    text: 'Professional website at a fraction of what agencies quoted me.'
  }];
  return <section id="demos" className="py-16 px-4 md:px-6" style={{
    backgroundColor: '#050505'
  }} data-id="element-128">
      <div className="max-w-6xl mx-auto" data-id="element-129">
        <div className="text-center mb-6 reveal" data-id="element-130">
          <div className="inline-flex items-center space-x-2 bg-[#c9a84c]/10 border border-[#c9a84c]/30 rounded-full px-4 py-1.5 mb-4" data-id="element-131">
            <Hotel className="w-4 h-4 text-[#c9a84c]" data-id="element-132" />
            <span className="text-[#c9a84c] text-sm font-medium" data-id="element-133">
              Demo Hotel Websites We Built
            </span>
          </div>
          <h2 className="text-3xl md:text-4xl font-bold text-white mb-4" data-id="element-134">
            See It In Action
          </h2>
          <p className="text-white/60" data-id="element-135">
            Real websites we've built — live and ready to explore.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-20" data-id="element-136">
          {demos.map((demo, idx) => <a key={idx} href={demo.url} target="_blank" rel="noopener noreferrer" className="premium-card rounded-xl overflow-hidden group reveal block" style={{
          transitionDelay: `${idx * 100}ms`
        }} data-id="element-137">
              {/* Thumbnail */}
              <div className="relative h-52 overflow-hidden" data-id="element-138">
                <img src={demo.thumbnail} alt={demo.title} className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105" onError={e => {
              // Fallback to gradient if thumbnail fails
              const target = e.currentTarget;
              target.style.display = 'none';
              const fallback = target.nextElementSibling as HTMLElement;
              if (fallback) fallback.style.display = 'flex';
            }} data-id="element-139" />
                {/* Fallback gradient */}
                <div className={`absolute inset-0 bg-gradient-to-br ${demo.gradient} items-center justify-center hidden`} data-id="element-140">
                  <div className="text-center px-4" data-id="element-141">
                    <Hotel className="w-10 h-10 text-[#c9a84c] mx-auto mb-2" data-id="element-142" />
                    <span className="text-xl font-bold text-white drop-shadow-md" data-id="element-143">
                      {demo.title}
                    </span>
                  </div>
                </div>
                {/* Hover overlay */}
                <div className="absolute inset-0 bg-black/40 group-hover:bg-black/20 transition-colors duration-300 flex items-end" data-id="element-144">
                  <div className="p-4 w-full bg-gradient-to-t from-black/80 to-transparent" data-id="element-145">
                    <p className="text-white font-bold text-sm" data-id="element-146">{demo.title}</p>
                    <p className="text-white/60 text-xs" data-id="element-147">{demo.subtitle}</p>
                  </div>
                </div>
              </div>

              {/* CTA */}
              <div className="p-5 text-center" style={{
            backgroundColor: '#0a0a0a'
          }} data-id="element-148">
                <span className="inline-flex items-center text-[#c9a84c] font-medium group-hover:underline" data-id="element-149">
                  View Live Demo{' '}
                  <ArrowRight className="w-4 h-4 ml-1 transition-transform group-hover:translate-x-1" data-id="element-150" />
                </span>
              </div>
            </a>)}
        </div>

        {/* Testimonials */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 reveal" data-id="element-151">
          {testimonials.map((t, idx) => <div key={idx} className="border border-white/[0.06] p-6 rounded-xl" style={{
          backgroundColor: '#0a0a0a'
        }} data-id="element-152">
              <div className="flex space-x-1 mb-4" data-id="element-153">
                {[1, 2, 3, 4, 5].map(s => <Star key={s} className="w-4 h-4 text-[#c9a84c] fill-[#c9a84c]" data-id="element-154" />)}
              </div>
              <p className="text-white/90 mb-4" data-id="element-155">"{t.text}"</p>
              <div data-id="element-156">
                <p className="text-white font-bold text-sm" data-id="element-157">{t.name}</p>
                <p className="text-white/50 text-xs" data-id="element-158">{t.role}</p>
              </div>
            </div>)}
        </div>
        <p className="text-center text-xs text-white/30 mt-8 reveal" data-id="element-159">
          * Sample testimonials — real reviews coming soon
        </p>
      </div>
      <SectionDivider data-id="element-160" />
    </section>;
}